type CommentsResponse = {
	lastPage: boolean,
	comments: Array<{
		comment: string
		comment_for: string,
		rating: string,
		roundedRating: string,
		date: string
	}>
};

// toggle overflow comment open and closed
function toggleCommentOpenAndClose(event: Event, item: HTMLElement) {
	event.preventDefault();
	if(item.classList.contains('active')) {
		item.classList.remove('active');
	} else {
		item.classList.add('active');
	}
}

function getNextBatchOfReviews(block: HTMLElement): Promise<{ lastPage: boolean, comments: HTMLElement[] }> {
	const nextPage = parseInt(block.getAttribute('data-next-page') ?? '0');
	let seed: string|number;
	if (!block.hasAttribute('data-seed')) {
		seed = Date.now().toString();
		block.setAttribute('data-seed', seed);
	} else {
		seed = block.getAttribute('data-seed')!;
	}

	const url = new URL(`/wp-json/plaudit/summitortho/v1/pressganey-reviews/${block.getAttribute('data-entity-type')}/${block.getAttribute('data-entity-id')}/${seed}/${block.getAttribute('data-per-page')}/${nextPage}`, document.baseURI);
	block.setAttribute('data-next-page', (nextPage + 1).toString());
	return fetch(url, {method: 'POST'})
		.then<CommentsResponse>(resp => resp.json())
		.then(json => {
			const templateRoot = (document.getElementById('press-ganey-review-template') as HTMLTemplateElement).content.firstElementChild;
			if (!templateRoot) {
				return {lastPage: false, comments: []};
			}
			return {
				lastPage: json.lastPage,
				comments: json.comments.map(comment => {
					const card = templateRoot.cloneNode(true) as HTMLElement;
					card.querySelectorAll<HTMLElement>('.comment').forEach(node => {
						const splitPoint = comment.comment.length > 100 ? comment.comment.lastIndexOf(' ', 100) : -1;
						if (splitPoint !== -1) {
							node.innerHTML = '';
							// add toggle indicator class to item
							node.classList.add('toggleable');
							// add toggle event to update class on click
							node.addEventListener('click', event => toggleCommentOpenAndClose(event, node));

							const part1 = comment.comment.substring(0, splitPoint);
							const part2 = comment.comment.substring(splitPoint);

							const span1 = document.createElement('span');
							span1.classList.add('comment__part1');
							// added extra space to account for 'read more'
							span1.innerText = part1 + ' ';
							node.appendChild(span1);

							const more = document.createElement('a');
							more.setAttribute('href', '#');
							more.classList.add('comment__more');
							more.innerText = "Read More";
							node.appendChild(more);

							const span2 = document.createElement('span');
							span2.classList.add('comment__part2');
							span2.innerText = part2;
							node.appendChild(span2);
						} else {
							node.innerText = comment.comment;
						}
					});
					if (comment.rating) {
						card.querySelectorAll<HTMLElement>('.wp-block-plaudit-star-rating-display').forEach(rating => {
							rating.setAttribute('data-rating', comment.rating);
							rating.setAttribute('data-rounded-rating', comment.roundedRating);
						});
					} else {
						card.querySelectorAll<HTMLElement>('.wp-block-plaudit-star-rating-display').forEach(rating => rating.remove());
					}
					card.querySelectorAll<HTMLElement>('.rating-description')
						.forEach(ratingDescription => {
							ratingDescription.setAttribute('aria-label',
								ratingDescription.getAttribute('aria-label')?.replace('{rating}', comment.rating) ?? '');
							ratingDescription.innerText = ratingDescription.innerText.replace('{rating}', comment.rating);
						});
					card.querySelectorAll<HTMLElement>('.comment-for').forEach(commentFor => commentFor.innerText = comment.comment_for);
					card.querySelectorAll<HTMLElement>('.date').forEach(date => date.innerText = comment.date);
					return card;
				})
			};
		})
		.catch(() => ({lastPage: false, comments: []}));
}
async function loadNextBatchOfReviews(block: HTMLElement) {
	block.classList.toggle('loading', true);
	const reviews = await getNextBatchOfReviews(block);
	if (reviews.lastPage) {
		block.querySelector('.load-more-reviews')?.remove();
	}
	block.querySelector('.loading-spinner')?.before(...reviews.comments);
	block.classList.toggle('loading', false);
}

function setUpReviewsBlock(block: HTMLElement) {
	block.querySelector('.load-more-reviews')?.addEventListener('click', () => loadNextBatchOfReviews(block));
	if (block.getAttribute('data-next-page') === '1') {
		loadNextBatchOfReviews(block);
	}
}

document.addEventListener('DOMContentLoaded', () => document.querySelectorAll<HTMLElement>('.wp-block-plaudit-expert-or-location-reviews')
	.forEach(block => setUpReviewsBlock(block)));

new MutationObserver(mutations => {
	for (const mutation of mutations) {
		for (const addedNode of mutation.addedNodes) {
			if (addedNode instanceof HTMLElement) {
				addedNode.querySelectorAll<HTMLElement>('.wp-block-plaudit-expert-or-location-reviews')
					.forEach(block => setUpReviewsBlock(block));
			}
		}
	}
}).observe(document, {subtree: true, childList: true});
